const relatedList = [
    {
        name: "Seafarer",
        category: "TRAVEL & HOTELS",
        price: 69,
        image: "https://previews.customer.envatousercontent.com/files/362567171/00_preview.__large_preview.jpg",
        link: "https://qodeinteractive.com/wordpress-theme/seafarer-yacht-and-boat-rental-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Kamperen",
        category: "TRAVEL & HOTELS",
        price: 75,
        image: "https://previews.customer.envatousercontent.com/files/354941098/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/kamperen-camping-and-adventure-tourism/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Augustine",
        category: "TRAVEL & HOTELS",
        price: 79,
        image: "https://previews.customer.envatousercontent.com/files/327431833/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/alloggio-hotel-booking-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Iver",
        category: "TRAVEL & HOTELS",
        price: 75,
        image: "https://previews.customer.envatousercontent.com/files/262083116/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/iver-a-modern-hotel-and-booking-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Alloggio",
        category: "TRAVEL & HOTELS",
        price: 79,
        image: "https://previews.customer.envatousercontent.com/files/385229442/alloggio.__large_preview.jpg",
        link: "https://qodeinteractive.com/wordpress-theme/alloggio-hotel-booking-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "BonVoYage",
        category: "TRAVEL & HOTELS",
        price: 69,
        image: "https://previews.customer.envatousercontent.com/files/243944603/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/bonvoyage-travel-agency-and-tour-booking-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Wanderers",
        category: "TRAVEL & HOTELS",
        price: 75,
        image: "https://previews.customer.envatousercontent.com/files/320201133/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/wanderers-an-adventurous-theme-for-travel-and-tourism/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Klippe",
        category: "TRAVEL & HOTELS",
        price: 69,
        image: "https://previews.customer.envatousercontent.com/files/242229428/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/klippe-adventure-tours-and-extreme-sports-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "FiceStart",
        category: "TRAVEL & HOTELS",
        price: 69,
        image: "https://previews.customer.envatousercontent.com/files/239947585/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/fivestar-theme-for-hotels-and-resort-booking/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Albergo",
        category: "TRAVEL & HOTELS",
        price: 75,
        image: "https://previews.customer.envatousercontent.com/files/266842826/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/albergo-hotel-and-accommodation-booking-theme/?utm_campaign=select&utm_source=toolbar",
    },
    {
        name: "Getaway",
        category: "TRAVEL & HOTELS",
        price: 75,
        image: "https://previews.customer.envatousercontent.com/files/336718142/00_preview.__large_preview.png",
        link: "https://qodeinteractive.com/wordpress-theme/getaway-travel-and-tourism-theme/?utm_campaign=select&utm_source=toolbar",
    },
    
]

export default relatedList